let maxmindLoadCalled = false;

/**
 * See:
 * https://dev.maxmind.com/minfraud/evaluate-a-transaction
 * https://dev.maxmind.com/minfraud/track-devices
 */
export const loadMaxmindMinfraudDeviceTracking = () => {
	if (maxmindLoadCalled) {
		return;
	}

	maxmindLoadCalled = true;

	// Arbitrarily delay this to avoid any possible UI jank
	// during slide transitioning, etc, caused by high main
	// JS thread CPU usage when it executes.
	setTimeout(() => {
		var mmapiws = window.__mmapiws = window.__mmapiws || {};
		mmapiws.accountId = '120509';
		var element = document.createElement('script');
		element.async = true;
		element.src = 'https://device.maxmind.com/js/device.js';
		document.body.appendChild(element);
	}, 1000);
}

export const trackGtmEvent = ({ event, category, action = '', label = '', value, ...rest }) => {
	try {
		dataLayer.push(
			value
				? {
					...rest,
					event: event || category,
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
					eventValue: value,
				}
				: {
					...rest,
					event: event || category,
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
				}
		);
	} catch (e) {
		console.error(e);
	}
};

export const trackBingConversion = ({ action, value }) => {
	const track = new Image();
	track.src = `//flex.msn.com/mstag/tag/9eaf3126-408c-4ff7-a983-d0338a6444c2/analytics.html?dedup=1&domainId=3147929&type=1&revenue=${value}&actionid=${action}`;
};

export const conversions = {
	trackGtmEvent,
	trackBingConversion,
};
export default conversions;
